/**
 * Site password gate (optional) — same origin in dev (CRA proxy), or set REACT_APP_API_URL for production.
 */
function trimBase(url) {
  return String(url || '')
    .trim()
    .replace(/\/$/, '');
}

export function getApiBase() {
  return trimBase(process.env.REACT_APP_API_URL);
}

function pathOnApi(suffix) {
  const b = getApiBase();
  return b ? `${b}${suffix}` : suffix;
}

export function siteAuthStatusUrl() {
  return pathOnApi('/api/auth/status');
}

export function siteAuthLoginUrl() {
  return pathOnApi('/api/auth/site-login');
}

export function siteAuthLogoutUrl() {
  return pathOnApi('/api/auth/site-logout');
}

/**
 * When the front-end is built with REACT_APP_API_URL, failed auth checks are treated as real errors
 * (private deploy). When unset (typical local dev with proxy), a failed /api call means "no gate" so the app still loads.
 */
export function isStrictApiMode() {
  return Boolean(getApiBase());
}
